import React from 'react'

const SwitchTab = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="tabs tabs-boxed flex-nowrap bg-subtle p-1 rounded-full w-fit">
      {tabs.map((tab) => (
        <a
          key={tab.value}
          className={`tab whitespace-nowrap text-[13px] ${
            activeTab === tab.value && 'tab-active'
          }`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </a>
      ))}
    </div>
  )
}

export default SwitchTab
